import router from './router'
import store from './store'
import { getToken, removeToken, getMenuIds, removeMenuIds } from "./utils/token";
import { getMyMenus } from "@/api/sysmanage";

import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式

const whiteList = ['/login', '/authredirect']

router.beforeEach((to, from, next) => {
  NProgress.start();

  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/main' });
    } else {
      // 路由未初始化（刷新页面后 store 被清空）
      if (!store.state.permission.isRoutesInitialized) {
        const menuIds = getMenuIds();
        if (!menuIds) {
          // 没有 menuIds，重新登录
          removeToken();
          next('/login');
          return;
        }
        getMyMenus({ menu_ids: menuIds }).then(menuRes => {
          const menus = menuRes.data || [];
          store.dispatch('GenerateRoutes', { menus }).then(() => {
            router.addRoutes(store.getters.addRouters);
            next({ ...to }); // 确保 addRoutes 完成后再跳转
          });
        }).catch(() => {
          removeToken();
          removeMenuIds();
          next('/login');
        });
      } else {
        store.dispatch('getNowRoutes', to);
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
